import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import LoadingSpinner from "../composant_reutilisable/loading";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';


const Inscription = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        reference: "",
        nom: "",
        prenoms: "",
        tel: "", // Initialiser avec "22901" pour le Bénin
        email: "",
        mdp1: "",
        mdp2: "",
        type_compte: "",
    });
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [showPassword1, setShowPassword1] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    // Gérer le changement des inputs
    // const handleChange = (e) => {
    //     setFormData({ ...formData, [e.target.name]: e.target.value });
    // };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: name === 'nom' ? value.toUpperCase() : value
        });
    };


    useEffect(() => {
        // Initialiser avec "22901" si le champ tel est vide
        if (!formData.tel) {
            setFormData(prev => ({ ...prev, tel: "22901" }));
        }
    }, []);


    const handlePhoneChange = (value, country) => {
        // Pour tous les pays, d'abord nettoyer la valeur
        const numericValue = value.replace(/\D/g, '');

        // Si le pays est Bénin (229)
        if (country.dialCode === "229") {
            // Si la valeur est vide ou ne commence pas par 22901, on force le format
            if (!numericValue.startsWith('22901') || numericValue.length < 5) {
                // Garder les chiffres saisis après 229 (max 8 chiffres)
                const userDigits = numericValue.replace(/^229/, '').replace(/^0?/, '').slice(0, 8);
                setFormData(prev => ({ ...prev, tel: '22901' + userDigits }));
                return;
            }

            // Limiter à 13 chiffres maximum (22901 + 8 chiffres)
            const limitedValue = numericValue.slice(0, 13);
            setFormData(prev => ({ ...prev, tel: limitedValue }));
        } else {
            // Pour les autres pays, utiliser juste le code pays + numéro saisi
            // Ne pas ajouter de "01" automatique
            setFormData(prev => ({ ...prev, tel: numericValue }));
        }
    };


    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 7000);
    };

    // Gérer l'envoi du formulaire
    const handleSubmit = async (e) => {
        e.preventDefault();

        // if (!formData.reference) {
        //     showAlert("Le champ Référence est manquant.", "danger");
        //     window.scrollTo(0, 0);
        //     return;
        // }
        if (!formData.nom) {
            showAlert("Le champ nom est manquant.", "danger");
            window.scrollTo(0, 0);
            return;
        }
        if (!formData.prenoms) {
            showAlert("Le champ prénom est manquant.", "danger");
            window.scrollTo(0, 0);
            return;
        }
        // if (!formData.type_compte) {
        //     showAlert("Le champ Type de compte est obligatoire.", "danger");
        //     window.scrollTo(0, 0);
        //     return;
        // }


        // Vérification pour email
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const Email = (formData.email || "").trim();
        // Vérifie que l'email est renseigné
        if (!Email) {
            showAlert("L'adresse email est obligatoire.", 'danger');
            window.scrollTo(0, 0);
            return;
        }
        // Vérifie que l'email est valide
        if (!emailRegex.test(Email)) {
            showAlert("L'email saisi n'est pas valide !", 'danger');
            window.scrollTo(0, 0);
            return;
        }

        if (!formData.tel) {
            showAlert("Le champ telephone est manquant.", "danger");
            window.scrollTo(0, 0);
            return;
        }
        if (!formData.mdp1) {
            showAlert("Le mot de passe est manquant.", "danger");
            window.scrollTo(0, 0);
            return;
        }
        if (!formData.mdp2) {
            showAlert("La confirmation du mot de passe est manquant.", "danger");
            window.scrollTo(0, 0);
            return;
        }
        if (formData.mdp1 !== formData.mdp2) {
            showAlert("Les mots de passe ne correspondent pas.", "danger");
            window.scrollTo(0, 0);
            return;
        }

        setIsLoading(true);

        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/inscription/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ formData }),
            });

            const data = await response.json();
            setIsLoading(false);

            if (response.ok) {
                const userId = data.utilisateur.id;
                // const token = data.token;
                // localStorage.setItem('token', token);
                localStorage.setItem('userId', userId)
                localStorage.setItem("groupe_id", data.utilisateur.groupe_id);;
                showAlert("Inscription réussie ! Vous pouvez maintenant vous connecter.", "success");
                localStorage.setItem("code_expires_at", data.utilisateur.code_expires_at);
                // navigate("/Verification", { state: { email: formData.email, code_expires_at: data.utilisateur.code_expires_at } });
                // navigate("/Verification", { state: { email: formData.email } });
                navigate("/Menu");
            } else {
                showAlert(data.message, "danger");
                return;
            }

        } catch (error) {
            setIsLoading(false);
            showAlert("Erreur de connexion au serveur.", "danger");
        }
    };

    return (
        <>
            {isLoading ? (
                <LoadingSpinner />
            ) : (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: "100vh" }}
                >
                    <div className="ibox" style={{ width: "100%", maxWidth: "450px" }}>
                        <div className="ibox-content">
                            <h3 className="m-t-none m-b text-center">Créer un compte</h3>


                            {alert.message && (
                                <div className={`alert alert-${alert.type}`}>
                                    {alert.message}
                                </div>
                            )}

                            <form>
                                {/* <div className="form-group row">
                                    <div className="col-sm-4">
                                        <label className="col-form-label" style={{ whiteSpace: "nowrap" }}>
                                            Type de compte
                                        </label>
                                        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                                    </div>
                                    <div className="col-sm-8">
                                        <select
                                            name="type_compte"
                                            className="form-control"
                                            value={formData.type_compte}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">-- Sélectionnez --</option>
                                            <option value="bailleur">Bailleur</option>
                                            <option value="transporteur">Transporteur</option>
                                            <option value="autre">Autre</option>
                                        </select>
                                    </div>
                                </div> */}
                                {/* {formData.type_compte !== 'autre' &&
                                    <div className="form-group row">
                                        <div className="col-sm-4">
                                            <label className="col-form-label" style={{ whiteSpace: "nowrap" }}>
                                                Référence
                                            </label>
                                            <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                                        </div>
                                        <div className="col-sm-8">
                                            <input
                                                type="text"
                                                name="reference"
                                                placeholder="Saisir la référence"
                                                className="form-control"
                                                value={formData.reference}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                } */}
                                <div className="form-group row">
                                    <div className="col-sm-4">
                                        <label className="col-form-label" style={{ whiteSpace: "nowrap" }}>
                                            Nom
                                        </label>
                                        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                                    </div>
                                    <div className="col-sm-8">
                                        <input
                                            type="text"
                                            name="nom"
                                            placeholder="Saisir le nom"
                                            className="form-control"
                                            value={formData.nom}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-sm-4">
                                        <label className="col-form-label" style={{ whiteSpace: "nowrap" }}>
                                            Prénoms
                                        </label>
                                        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                                    </div>
                                    <div className="col-sm-8">
                                        <input
                                            type="text"
                                            name="prenoms"
                                            placeholder="Saisir le prénom"
                                            className="form-control"
                                            value={formData.prenoms}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-sm-4">
                                        <label className="col-form-label" style={{ whiteSpace: "nowrap" }}>
                                            Email
                                        </label>
                                        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                                    </div>
                                    <div className="col-sm-8">
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Saisir l'email"
                                            className="form-control"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-sm-4">
                                        <label className="col-form-label" style={{ whiteSpace: "nowrap" }}>
                                            Téléphone
                                        </label>
                                        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                                    </div>
                                    <div className="col-sm-8">
                                        {/* <PhoneInput
                                            // type="number"
                                            name="tel"
                                            //placeholder="Entrer votre téléphone"
                                            className="form-control"
                                            value={formData.tel}
                                            onChange={handlePhoneChange}
                                            required
                                            inputStyle={{ width: '100%', padding: '33px' }}
                                            containerStyle={{ width: '100%' }}
                                            inputProps={{
                                                name: 'tel',
                                                required: true,
                                            }}
                                            dropdownStyle={{
                                                maxHeight: '500px',
                                                overflowY: 'auto',
                                                zIndex: 1050,
                                            }}
                                        /> */}

                                        <PhoneInput
                                            name="tel"
                                            value={formData.tel}
                                            country="bj"
                                            onChange={(value, country) => handlePhoneChange(value, country)}
                                            onKeyDown={(e) => {
                                                const numericValue = formData.tel.replace(/\D/g, '');
                                                // Vérifier si c'est le Bénin
                                                if (numericValue.startsWith('229')) {
                                                    // Empêcher la suppression du préfixe 22901
                                                    if (e.key === 'Backspace' || e.key === 'Delete') {
                                                        if (numericValue.length <= 5) { // 22901 = 5 chiffres
                                                            e.preventDefault();
                                                        }
                                                    }
                                                    // Empêcher d'ajouter plus de 13 chiffres
                                                    else if (numericValue.length >= 13 &&
                                                        !['ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }
                                            }}
                                            required
                                            placeholder=""
                                            inputStyle={{
                                                width: "100%",
                                                height: "33px",
                                                fontSize: "12px",
                                                paddingLeft: "55px"
                                            }}
                                            containerStyle={{ width: "100%" }}
                                            inputProps={{
                                                name: "tel",
                                                required: true,
                                            }}
                                            dropdownStyle={{
                                                maxHeight: "200px",
                                                overflowY: "auto",
                                                zIndex: 1050,
                                            }}
                                            onCountryChange={(country) => {
                                                if (country.dialCode === "229") {
                                                    // Quand on revient au Bénin, forcer le format 22901
                                                    const currentNumeric = formData.tel.replace(/\D/g, '');
                                                    if (!currentNumeric.startsWith("22901")) {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            tel: '22901' + currentNumeric.replace(/^229/, '').replace(/^0?/, '').slice(0, 8)
                                                        }));
                                                    }
                                                } else {
                                                    // Pour les autres pays, enlever tout préfixe spécifique
                                                    const currentNumeric = formData.tel.replace(/\D/g, '');
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        tel: currentNumeric.replace(/^22901/, '').replace(/^229/, '')
                                                    }));
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                {/* <div className="form-group row">
                                    <div className="col-sm-4">
                                        <label className="col-form-label" style={{ whiteSpace: "nowrap" }}>
                                            Type de compte
                                        </label>
                                        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                                    </div>
                                    <div className="col-sm-8">
                                        <select
                                            name="type_compte"
                                            className="form-control"
                                            value={formData.type_compte}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">-- Sélectionnez --</option>
                                            <option value="bailleur">Bailleur</option>
                                            <option value="transporteur">Transporteur</option>
                                            <option value="autre">Autre</option>
                                        </select>
                                    </div>
                                </div> */}

                                <div className="form-group row">
                                    <div className="col-sm-4">
                                        <label className="col-form-label" style={{ whiteSpace: "nowrap" }}>
                                            Mot de passe
                                        </label>
                                        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                                    </div>
                                    <div className="col-sm-8 position-relative">
                                        <input
                                            type={showPassword1 ? "text" : "password"}
                                            name="mdp1"
                                            placeholder="Saisir le mot passe"
                                            className="form-control"
                                            value={formData.mdp1}
                                            onChange={handleChange}
                                            required
                                        />
                                        <span
                                            onClick={() => setShowPassword1(!showPassword1)}
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                right: "25px",
                                                transform: "translateY(-50%)",
                                                cursor: "pointer",
                                                color: "#666",
                                            }}
                                        >
                                            {showPassword1 ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </div>
                                </div>

                                <div className="form-group row mt-2">
                                    <div className="col-sm-4">
                                        <label className="col-form-label d-inline-flex">
                                            Confirmer
                                            <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                                        </label>
                                    </div>
                                    <div className="col-sm-8 position-relative">
                                        <input
                                            type={showPassword2 ? "text" : "password"}
                                            name="mdp2"
                                            placeholder="Retaper le mot de passe"
                                            className="form-control"
                                            value={formData.mdp2}
                                            onChange={handleChange}
                                            required
                                        />
                                        <span
                                            onClick={() => setShowPassword2(!showPassword2)}
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                right: "25px",
                                                transform: "translateY(-50%)",
                                                cursor: "pointer",
                                                color: "#666",
                                            }}
                                        >
                                            {showPassword2 ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </div>
                                </div>

                                <div className="text-right">
                                    <button className="btn btn-sm btn-success" type="submit" onClick={handleSubmit}>
                                        <strong>S'inscrire</strong>
                                    </button>
                                </div>
                            </form>

                            <div className="text-center mt-3">
                                <p>
                                    Déjà un compte ? <Link to="/">Se connecter</Link>
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div class="col-md-12 w-100 text-center">
                                <small><a href="https://www.adnservicespro.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#3088C0" }}>ADN Services</a> &copy; 2025. Tous droits réservés | Réalisé par <a href="https://inovact.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#3088C0" }}>INOVACT SARL</a></small>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Inscription;
